import { load } from "./localStorage"

const MIN_WEIGHT = 30
const MAX_WEIGHT = 300

const MIN_HEIGHT = 90
const MAX_HEIGHT = 250

const MIN_AGE = 18
const MAX_AGE = 100

isString = (value) => typeof value === "string"

const validators = {
  measurementSystem: (value) => ["imperial", "metric"].includes(value),
  gender: (value) => ["female", "male"].includes(value),
  goal: (value) => ["Lose weight", "Develop healthy habits"].includes(value),
  email: (value) => isString(value) && value.match(/^\S+@\S+\.\S+$/),
  age: (value) => value !== null && Number(value) >= MIN_AGE && Number(value) <= MAX_AGE,
  targetWeightKg: (value) => !!Number(value),
  targetWeightLbs: (value) => !!Number(value),
  firstName: (value) => isString(value) && value.length > 0 && !!value.trim(),
  weightKg: (value) => value !== null && Number(value) >= MIN_WEIGHT && Number(value) <= MAX_WEIGHT,
  weightLbs: (value) => {
    if (value === null) return false

    const weight = Number(value) * 0.453592

    return weight >= MIN_WEIGHT && weight <= MAX_WEIGHT
  },
  heightCm: (value) => value !== null && Number(value) >= MIN_HEIGHT && Number(value) <= MAX_HEIGHT,
  heightFt: (value, { heightFt, heightIn }) => {
    if (value === null) return false

    const height = Number(heightFt) * 30.48 + Number(heightIn) * 2.54

    return height >= MIN_HEIGHT && height <= MAX_HEIGHT
  },
  heightIn: (value, { heightFt, heightIn }) => {
    if (value === null || value > 12) return false

    const height = Number(heightFt) * 30.48 + Number(heightIn) * 2.54

    return height >= MIN_HEIGHT && height <= MAX_HEIGHT
  },
  privacyAgreement: (value) => value !== "17-create-plan.pa_answer2",
}

const validate = (data) => {
  const LOCAL_STORAGE_KEY = "translations"
  const { values } = load(LOCAL_STORAGE_KEY)

  const errors = {}
  let hasErrors = false

  Object.entries(data).forEach(([field, value]) => {
    const validator = validators[field]

    if (validator && !validator(value, data)) {
      hasErrors = true
      errors[field] = values.translation.errors[field]
    }
  })

  return { hasErrors, errors }
}

export default validate
